import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import { ui } from '@wp-g2/styles';
import { mergeRefs } from '@wp-g2/utils';
import React from 'react';
import { FlexItem } from '../Flex';
import { View } from '../View';
import SelectArrow from './SelectArrow';
import { useSelect } from './useSelect';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./types').Props, 'select'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function Select(props, forwardedRef) {
  var _useSelect = useSelect(props),
      _useSelect$as = _useSelect.as,
      as = _useSelect$as === void 0 ? 'select' : _useSelect$as,
      inputProps = _useSelect.inputProps,
      inputRef = _useSelect.inputRef,
      multiple = _useSelect.multiple,
      prefix = _useSelect.prefix,
      resizer = _useSelect.resizer,
      sizes = _useSelect.sizes,
      suffix = _useSelect.suffix,
      suffixProps = _useSelect.suffixProps,
      otherProps = _objectWithoutProperties(_useSelect, ["as", "inputProps", "inputRef", "multiple", "prefix", "resizer", "sizes", "suffix", "suffixProps"]);

  return /*#__PURE__*/React.createElement(View, otherProps, prefix && /*#__PURE__*/React.createElement(FlexItem, ui.$('SelectPrefix'), prefix), /*#__PURE__*/React.createElement(View, Object.assign({
    as: as
  }, inputProps, {
    ref: mergeRefs([forwardedRef, inputRef])
  })), suffix && /*#__PURE__*/React.createElement(FlexItem, Object.assign({}, ui.$('SelectSuffix'), suffixProps), resizer, suffix), !multiple && /*#__PURE__*/React.createElement(SelectArrow, null));
}
/**
 * `Select` is a form component lets users choose options from an options menu.
 *
 * @example
 * ```jsx
 * import { Select } from `@wp-g2/components`
 *
 * function Example() {
 *   return (
 *     <Select>
 *       <option>Ana</option>
 *       <option>Elsa</option>
 *       <option>Kristoff</option>
 *       <option>Olaf</option>
 *     </Select>
 *   );
 * }
 * ```
 */


var ConnectedSelect = contextConnect(Select, 'Select');
export default ConnectedSelect;